import { useEffect, useState } from 'react';

import { heapIdentify } from '@modernanimal/common';

import useWebBookingStore from './store';

const HeapSubscriptions = () => {
    const [clientId, setClientId] = useState('');

    useEffect(() => {
        const unsubscribe = useWebBookingStore.subscribe(
            ({ client }) => setClientId(client.id)
        );

        // Cleanup function to unsubscribe when the component is unmounted
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (clientId) {
            heapIdentify(clientId);
        }
    }, [clientId]);

    return null;
};

export default HeapSubscriptions;
